<template>
  <!-- 班级课程 -->
  <div class="page-report">
    <div class="week-box" v-for="(item,index) in list" :key="index" >
      <div class="li-week">
        <div class="week-left">
          <div class="left">
            <p class="week-title">week 0{{ item && item.week }}</p>
          </div>
          <img src="../../../assets/images/grade/icon-edit.png" alt="" class="icon-edit"
          v-if="isAdminPermiss"
          @click="handleEditWeek(item,index)"/>
        </div>
        <div class="week-right" @click="handleCourseDorpDown(item,index)">
          <img src="@/assets/images/grade/icon-suo.png" class="icon-unlock" alt="" v-if="!item.unlock">
          <p class="down-title">
            {{item.isDropDown?'收起':'展开'}}
          </p>
          <img src="@/assets/images/grade/drop-up.png" alt="" class="icon-down" v-if="item && item.isDropDown"/>
          <img src="@/assets/images/grade/drop-down.png" alt="" class="icon-down" v-else/>
        </div>
      </div>
      <template v-if="item && item.isDropDown">
        <div class="day-box" v-if="item && item.courseTable.length">
          <div class="day-item" v-for="(acc,cindex) in item.courseTable" :key="cindex">
            <img src="../../../assets/images/grade/icon-doast.png" alt="" class="icon-doast"/>
            <div class="day-item-box">
              <p class="day-num">Day{{ acc && acc.day }}</p>
              <template v-if="acc && acc.content.length">
                <div class="day-main" v-for="(course,coIndex) in acc.content" :key="coIndex" @click="handleDialogUnlock(course,coIndex, item)">
                  <!-- 已完成 -->
                  <img src="../../../assets/images/grade/icon-completed.png" alt="" class="icon-start" v-if="course.showStatus ===1"/>
                  <!-- 进行中 -->
                  <img src="../../../assets/images/grade/icon-underway.png" alt="" class="icon-start" v-if="course.showStatus ===2"/>
                  <!-- 待开始 -->
                  <img src="../../../assets/images/grade/icon-start.png" alt="" class="icon-start" v-if="course.showStatus ===3"/>
                  <!-- 待测评 -->
                  <img src="../../../assets/images/grade/icon-evaluat.png" alt="" class="icon-start" v-if="course.showStatus ===4"/>
                  <div class="main-box" v-if="course && course.docuCourseCase">
                    <div class="box-head" v-if="isAdminPermiss">
                      <p class="box-title">{{course.docuCourseCase && course.docuCourseCase.title}}</p>
                      <img src="../../../assets/images/grade/icon-dot.png" @click.stop="handleOperate(course,coIndex)" alt="" class="icon-dot" v-if="isAdminPermiss"/>
                    </div>
                    <div class="box-head" v-else>
                      <p class="box-title">{{course.docuCourseCase && course.docuCourseCase.title}}</p>
                      <img src="../../../assets/images/grade/icon-dot.png" alt="" class="icon-dot" v-if="isAdminPermiss"/>
                    </div>
                    <div class="box-footer">
                      <p class="footer-title">课程学习</p>
                      <div class="footer-right">
                        <div class="item-unlock" v-if="`${course.docuCourseCase.isUnlock}` === '1' && !course.docuCourseCase.myUnlock">
                          <img src="@/assets/images/grade/icon-suo.png" class="icon-unlock" alt="" v-if="course && course.docuCourseCase.isUnlock">
                          <span class="txt">{{ course && course.docuCourseCase.unlockCost }}积分解锁</span>
                        </div>
                        <div class="footer-btn" v-if="item && item.unlock">学习</div>
                        <div class="status" v-else>待开课</div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div class="empty-block" v-else>
                <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
                <div class="empty-txt">暂无内容</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="empty-block" v-if="!list.length">
      <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
      <div class="empty-txt">暂无内容</div>
    </div>
    <dialogUnlock ref="dialogUnlock" @unlockSuccess="handleJump" :dataProps="dataProps"></dialogUnlock>
    <weekPopup ref="weekPopup" :list="weekList" @changeDay="changeDay"></weekPopup>
    <dialogDel ref="dialogDel" @handleDelSave="handleDelSave"></dialogDel>
    <van-popup v-model="isPopopShow" round position="bottom" :style="{ height: '15%' }" >
      <div class="popup-box">
        <ul class="popup-menu">
          <li class="menu-li" @click="handleDelPopup">删除</li>
        </ul>
        <div class="footer" @click="handlePopupClose">取消</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import dialogUnlock from '@/components/dialogUnlock.vue'
import dialogDel from './dialogDel.vue'
import weekPopup from './weekPopup.vue'
import { getClassCourse, delClassCourse } from '@/api/grade'
import {isScorm} from '../../../api/scorm'
export default {
  name: 'journeyPage',
  components: {
    dialogUnlock,
    weekPopup,
    dialogDel
  },
  props: {
    classId: '',
    isAdminPermiss: { // 超管,管理员
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      finished: false,
      isPopopShow: false,
      delAcc: {},
      list: [],
      dayNum: null,
      editItem: {},
      activeNames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      activeCourse: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      loadingSke: true,
      journeyTopDetails: {},
      journeyMaps: [],
      stages: [],
      currentJourney: {},
      currentStages: {},
      stageId: '',
      stagesIndex: 0,
      dataDetails: {},
      currentJourneyTxts: '电生理成长之旅',
      classPermissions: {},
      dataProps: {
        unlockContent: '兑换班级课程',
        unlockTxt: '课程'
      },
      weekList: [{label: 'Day1', value: '1', checked: false}, {label: 'Day2', value: '2', checked: false},
        {label: 'Day3', value: '3', checked: false}, {label: 'Day4', value: '4', checked: false},
        {label: 'Day5', value: '5', checked: false}, {label: 'Day6', value: '6', checked: false},
        {label: 'Day7', value: '7', checked: false}
      ]
    }
  },
  created() {
    this.classPermissions = this.isWhiteUser ? {isJourneyEdit: false} : JSON.parse(sessionStorage.getItem('classPermissions'))
    this.handleLoad()
  },
  mounted() {
    sessionStorage.removeItem('selectCourse')
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    isWhiteUser() {
      return JSON.parse(sessionStorage.getItem('isWhiteUser'))
    }
  },
  methods: {
    handleDelPopup() {
      this.isPopopShow = false
      this.$refs.dialogDel.init(this.delAcc)
    },
    handleLoad() {
      getClassCourse(this.classId).then(res => {
        const data = res.data
        data.forEach(acc => {
          acc.isDropDown = true
        })
        this.list = data
      }).catch(err => {
        this.$toast.clear()
        console.log('err:', err)
      })
    },
    // 操作，删除
    handleOperate(acc, index) {
      this.isPopopShow = true
      this.delAcc = acc
    },
    handlePopupClose() {
      this.isPopopShow = false
      this.delAcc = {}
    },
    handleDelSave(val) {
      delClassCourse({id: val.id}).then(res => {
        this.$toast('删除成功')
        this.$refs.dialogDel.init()
        this.handlePopupClose()
        this.handleLoad()
      }).catch(err => {
        this.$toast(err.msg)
      })
    },
    handleEditWeek(item, index) {
      this.editItem = item // 编辑item
      this.$refs.weekPopup.init()
    },
    // 更改天数
    changeDay(val) {
      this.dayNum = val
      this.handleEdit()
    },
    // 选择课程
    handleEdit(item) {
      this.$router.push({
        path: '/gradeSelectCourse',
        query: {
          week: this.editItem.week,
          day: this.dayNum,
          classId: this.classId,
        }
      })
    },
    handleCourseDorpDown(item, index) {
      this.list[index].isDropDown = !this.list[index].isDropDown
    },
    async handleJump () {
      let item = this.dataDetails
      window.sessionStorage.setItem('entrance', '55')
      const query = {
        courseId: item.baseId,
        classId: this.classId,
        businessId: this.classId,
        entrance: '55',
        channel: '55'
      }
      const isscorm = await isScorm(item.baseId)
      let path = '/courserDetails'
      if (isscorm.data) {
        path = '/scormCourseDetail'
      }
      this.$router.push({path, query})
    },
    // 解锁
    handleDialogUnlock (item, index, itemday) {
      if (!itemday.unlock) {
        this.$toast('班级课程暂未开始！')
        return
      }
      this.dataDetails = item
      if (`${item.docuCourseCase.isUnlock}` === '1' && !item.docuCourseCase.myUnlock) {
        this.dataProps.baseId = item.baseId
        this.dataProps.unlockCost = item.docuCourseCase.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      this.handleJump()
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .van-skeleton {
  padding-top: 20px;
  box-sizing: border-box;
  .van-skeleton__row, .van-skeleton__title {
    background-color: #fff;
  }
}
.page-report {
  background-color: #f0f1f6;
  box-sizing: border-box;
  padding: 10px 10px 30px 10px;
  .li-week{
    background: url("../../../assets/images/grade/class-bg.png") no-repeat center center / 100% 100%;
    width: 100%;
    height: 17px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 5px;
    margin-top: 10px;
    .week-left{
      display: flex;
      align-items: center;
      flex: 1;
      .left{
        background: url("../../../assets/images/grade/icon-week.png") no-repeat center center / 100% 100%;
        width: 63px;
        height: 20px;
        padding:0 5px;
        display: flex;
        align-items: center;
        .week-title{
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 600;
          font-size: 12px;
          color: #FFFFFF;
        }
      }
      .icon-edit{
        width: 14px;
        height: 14px;
        margin-left: 10px;
      }
    }

    .week-right{
      position: relative;
      display: flex;
      align-items: center;
      flex: 1;
      justify-content: flex-end;
      .icon-unlock{
        width: 12px;
        margin-right: 9px;
        // height: 16px;
      }
      .down-title{
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #000000;
        margin-right: 6px;
      }
      .icon-down{
        width: 11px;
        height: 5px;

      }
    }
  }
  .week-box{
    position: relative;
    padding:8px 8px 12px 8px;
    background: #fff;
    border-radius: 12px;
    margin-bottom: 10px;
    .day-box{
      position: relative;
      // min-height: 200px;
      &::before{
        content: "";
        position: absolute;
        border-left: 1px dashed #EB1700;
        left: 14px;
        top: 0;
        width: 1px;
        height: 100%;
      }
      .day-item{
        display: flex;
        flex-direction: column;
        position: relative;
        margin-top: 10px;
        .icon-doast{
          position: absolute;
          left:8px;
          top: 0;
          width: 13px;
          height: 13px;
        }
        .day-item-box{
          position: relative;
          padding-left:24px;
          margin-bottom: 6px;
          .day-num{
            margin-top: -4px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #EB1700;
            margin-bottom: 2px;
            line-height: 20px;
          }
          .day-main{
            position: relative;
            display: flex;
            align-items: center;
            height: 69px;
            margin-bottom: 14px;
            &:last-child{
              margin-bottom: 0;
            }
            .icon-start{
              width: 21px;
              height: 69px;
            }
            .main-box{
              flex: 1;
              height: 69px;
              background: #F2F7FA;
              border-radius: 4px;
              padding:8px 6px;
              box-sizing: border-box;
              width: calc(100% - 21px);
              box-sizing: border-box;
              .box-head{
                display: flex;
                align-items: center;
                justify-content: space-between;
                .icon-dot{
                  width: 7px;
                  height: 3px;
                }
                .box-title{
                  position: relative;
                  font-family: Source Han Sans CN, Source Han Sans CN;
                  font-weight: 400;
                  font-size: 14px;
                  color: #000000;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  margin-right: 6px;
                }
              }
              .box-footer{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 8px;
                .footer-title{
                  font-family: Source Han Sans CN, Source Han Sans CN;
                  font-weight: 400;
                  font-size: 12px;
                  color: #7A8494;
                  line-height: 24px;
                }
                .footer-right{
                  flex: 1;
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;
                  .footer-btn{
                    width: 56px;
                    text-align: center;
                    border: 1px solid #eb1700;
                    border-radius: 100px;
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-size: 14px;
                    font-weight: 400;
                    height: 22px;
                    line-height: 22px;
                    color: #fff;
                    margin-left: 4px;
                    background: #EB1700;
                  }
                  .item-unlock {
                    display: flex;
                    align-items: center;
                    height: 20px;
                    margin-top: 2px;

                    .icon-unlock {
                      width: 10px;
                      margin-right: 4px;
                      display: block;
                    }

                    .txt {
                      color: #EB1700;
                      font-size: 12px;
                    }
                  }
                  .status{
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-weight: 400;
                    font-size: 14px;
                    color: #7A8494;
                    margin-left: 14px;
                  }
                }
              }
            }
          }
        }
        .day-num{

        }
      }
    }
  }
}
.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 30px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
/deep/ .van-cell {
  padding: 0;
}

/deep/ .van-collapse-item__content {
  padding: 0;
}
.popup-box{
  background: #F8F8F8;
  position: relative;
  .popup-menu{
    position: relative;
    list-style: none;
    display: flex;
    flex-direction: column;
    background: #fff;
    margin-bottom: 9px;
    .menu-li{
      height: 48px;
      border-bottom: 1px solid #F3F3F3;
      box-sizing: border-box;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFang HK, PingFang HK;
      font-weight: 400;
      font-size: 16px;
      color: #000000;
    }
  }
  .footer{
    flex: 1;
    height: 80px;
    background: #fff;
    box-sizing: border-box;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFang HK, PingFang HK;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0,0,0,0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/journeyPage.vue